import styled from 'styled-components';

import CheckboxComponent from 'components/Checkbox';
import Label from 'components/Label';

export const Checkbox = styled(CheckboxComponent)`
  margin: 20px 0;

  & > .checkbox {
    height: 24px;
    width: 24px;
  }

  &:first-child {
    margin-top: 16px;
  }

  &:last-child {
    margin-bottom: 16px;
  }
`;

export const CheckboxLabel = styled(Label)`
  padding: 0 0 0 16px;
  font-size: 14px;
  color: ${({ theme }) => theme.filters.color};
`;

export const AirIcon = styled.img`
  max-width: 18px;
  max-height: 18px;
  vertical-align: middle;
  margin-right: 5px;
`;

export const CheckboxCount = styled.span`
  margin-left: auto;
`;
